var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-combo-boards grid grid--gap-1",
      class: "banners-count-" + _vm.bannersCount,
    },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [_c("rb-board-with-fields-on", [_vm._t("banners")], 2)],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 overflow-hidden" },
        [
          !_vm.isTablet
            ? _c(
                "rb-smart-container",
                {
                  attrs: {
                    "slides-per-view-desktop": 4,
                    "slides-per-view-mobile": 1,
                    "slides-per-view-tablet": 3,
                    "full-screen-mobile": _vm.fullScreenMobile,
                  },
                },
                [_vm._t("tiles")],
                2
              )
            : _c(
                "div",
                [
                  _c(
                    "rb-tiles-wrapper",
                    { attrs: { "slide-slot": _vm.slideSlot } },
                    [_vm._t("tiles")],
                    2
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }